// var configEnv = "development";
// var configEnv = "staging";
// var configEnv = "production";

var configEnv = process.env.REACT_APP_NODE_ENV;
if (!["development", "staging", "production"].includes(configEnv)) {
  throw new Error(`Invalid REACT_APP_NODE_ENV value: ${configEnv}`);
}

var config = {
  //##########Live config##########
  production: {
    appUrl: "https://clovernews365.com",
    apiUrl: "https://api.goldenclovercasino.com/api/v1",
    staticUrl: "https://api.goldenclovercasino.com/api/v1",
    publicDir: "https://goldenpeace34.clovernews365.com/public",
    liveChatUrl: "https://livechat.goldenclovercasino.com/php/app.php?widget-inline",
    FBAppId: "1172568450039492",
    GoogleClientId: "918922690152-tk90kb6fiq5ssekf7fcnn2d3hfrkvkkv.apps.googleusercontent.com",
    debug: false,
  },

  //#########Stage config########## Stage and live are the same as its demo
  staging: {
    appUrl: "https://play365.cbstagings.com",
    apiUrl: "https://play365api.cbstagings.com/api/v1",
    staticUrl: "https://play365api.cbstagings.com/api/v1",
    publicDir: "https://play365boss.cbstagings.com/public",
    liveChatUrl: "https://play365livechat.cbstagings.com/php/app.php?widget-inline",
    FBAppId: "1172568450039492",
    GoogleClientId: "918922690152-tk90kb6fiq5ssekf7fcnn2d3hfrkvkkv.apps.googleusercontent.com",
    debug: false,
  },

  //##########Local config##########
  development: {
    appUrl: "http://front.casino.local:3000",
    apiUrl: "http://api.casino.local:8002/api/v1",
    staticUrl: "http://api.casino.local:8002/api/v1",
    liveChatUrl: "http://livechat.casino.local:8003/php/app.php?widget-inline",
    fileSourceUrl: "http://admin.casino.local:8001/public",
    debug: true,
  },
};

var finalConfig = config[configEnv];

finalConfig.defaultLanguage = {
  code: "en",
  language: "English",
  flag_path:
    (finalConfig.fileSourceUrl || finalConfig.publicDir || "") +
    "/images/flags/svg/gb.svg",
};

finalConfig.authUiTheme = process.env.REACT_APP_AUTH_UI_THEME || "classic";

export default finalConfig;

// export default config[configEnv];
